import { type OperationResponse, type Parameters } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

interface OperationMethods {
  "setDefault"(
    parameters?: Parameters<Paths.SetDefault.PathParameters> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.SetDefault.Responses.$204>;
}

export const getCountryOperations = (client: AxiosInstance) => {
  const setDefault: OperationMethods["setDefault"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/country/{id}/set-default";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    setDefault,
  };
};
